import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$16,863 October sidehustle report",
  "description": "",
  "published": "2017-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/16661-october-sidehustle-report/swizec/7883"],
  "categories": "Business, Side Projects, sidehustle",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`October was fire 🔥`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`October sidehustle report gonna be 🔥 `}<a parentName="p" {...{
          "href": "https://t.co/pCxhBWhc1F"
        }}>{`pic.twitter.com/pCxhBWhc1F`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/924020785710227457"
      }}>{`October 27, 2017`}</a></blockquote>
    <p>{`The whole month comes down to dumb luck, timing, and seizing opportunities. And a little elbow grease.`}</p>
    <p>{`You see, October actually started way back in August. `}<a parentName="p" {...{
        "href": "https://www.meetup.com/Real-World-React/events/242620292/"
      }}>{`Real World React`}</a>{` was organizing a hack night and needed mentors. I said what the hell and signed up. They took me on.`}</p>
    <p>{`At the hack night, I met Ben, the organizer. He mentioned that he was looking for React trainers who could run workshops because Real World React's workshop and corporate training business is growing.`}</p>
    <p>{`I said, “Yep, I'm your man.”`}</p>
    <p>{`In mid-September, he pinged me and said they had a deal with StubHub to do an `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ix5iqTZ8WCo"
      }}>{`Intro to React and Redux workshop`}</a>{`, but nobody to do it. The usual guy dropped out.`}</p>
    <p>{`I sensed a disturbance in the force, but didn't want to push for a reason. Because screw `}<em parentName="p">{`why`}</em>{`, focus on YES LET'S DO THIS.`}</p>
    <p>{`So I prepared a full day workshop in like a week. 👇`}</p>
    <lite-youtube {...{
      "videoid": "ix5iqTZ8WCo",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`It went okay. Got some feedback, made some adjustments, prepared another full day workshop in a week for Redux, Day 2. 👇`}</p>
    <lite-youtube {...{
      "videoid": "FaAlBSVp9M0",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`That one went much better. More attendees stayed until the end, asked more questions, and generally had more fun. There may or may not have been an inside joke going around the room.`}</p>
    <p>{`I learned that people enjoy more handholding than I do myself and that they love it when `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/teaching-stubhub-react-redux/swizec/7860"
      }}>{`I draw on the whiteboard while talking about React and Redux`}</a>{`. Fun to do as well. Helps me think and keeps me from rambling :)`}</p>
    <p>{`That was the first half of the month.`}</p>
    <p>{`After those two weeks, life slowed because I was le tired. And no, I didn't `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=kCpjgl2baLs"
      }}>{`fire ze missiles`}</a></p>
    <p>{`Oh no, I did much more than fire ze missiles. I launched a last minute birthday promotion in the last week of October.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/11/2017-11-02-at-10.13-AM.png",
        "alt": null
      }}></img></p>
    <p>{`Built `}<a parentName="p" {...{
        "href": "https://swizec.com/30"
      }}>{`the landing page`}</a>{` in a couple hours overnight, wrote two launch emails, set up a Facebook ad and a Twitter ad. Made 203 sales in a day and a half.`}</p>
    <p>{`I was thinking a hundred sales would be my benchmark for success. Sold 2x that.`}</p>
    <p>{`Not sure what that says about my regular pricing. Maybe it's too high?`}</p>
    <p>{`Normal sales for React+D3v4 have pretty much dried up, but when there was a promotion, people pounced. 🤔`}</p>
    <p>{`More importantly, I'm getting very close to having a good framework for building landing pages. There's still some copypasta going on, but time to launch a good page has gone from "a few days" to "a couple hours".`}</p>
    <p>{`The key, really, was discovering `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/"
      }}>{`GatsbyJS`}</a>{`. Been looking for that for years and didn't even know it 🤙`}</p>
    <p>{`Here's the month in numbers 👇`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $16,863`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $6,888`}</p>
    <ul>
      <li parentName="ul">{`30-at-30: $5,818`}</li>
      <li parentName="ul">{`React + D3v4: $752`}</li>
      <li parentName="ul">{`React + D3 old versions: $77`}</li>
      <li parentName="ul">{`ES6 Cheatsheet: $76`}</li>
    </ul>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $392`}</p>
    <ul>
      <li parentName="ul">{`Why Programmers Work At Night: $29`}</li>
      <li parentName="ul">{`React + D3 old versions: $14`}</li>
      <li parentName="ul">{`React + D3v4: $348`}</li>
    </ul>
    <p><strong parentName="p">{`Patreon pledges:`}</strong>{` $180`}</p>
    <p><strong parentName="p">{`Amazon Associates:`}</strong>{` $22`}</p>
    <p><strong parentName="p">{`Workshops:`}</strong>{` $9,381`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 95 hours`}</p>
    <p><strong parentName="p">{`Expenses`}</strong></p>
    <ul>
      <li parentName="ul">{`Editor: $500`}</li>
      <li parentName="ul">{`VA: $400`}</li>
      <li parentName="ul">{`Facebook ads: $605`}</li>
      <li parentName="ul">{`Twitter ads: $200`}</li>
      <li parentName="ul">{`Drip: $149`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
      <li parentName="ul">{`Webfaction: $10`}</li>
      <li parentName="ul">{`LiveEdu Pro: $10`}</li>
      <li parentName="ul">{`AWS: $14`}</li>
      <li parentName="ul">{`now.sh: $15`}</li>
      <li parentName="ul">{`SmartBribe: $35`}</li>
      <li parentName="ul">{`Time Capsule: $299`}</li>
      <li parentName="ul">{`AirPods: $172`}</li>
      <li parentName="ul">{`2FA security keys: $43`}</li>
      <li parentName="ul">{`HDMI dongle: $16`}</li>
    </ul>
    <p><strong parentName="p">{`Effective hourly rate:`}</strong>{` $150/hour 😛`}</p>
    <p>{`Now I have two problems on my hand 👇`}</p>
    <p>{`First, I need to learn about cashflow management. 3x your J.O.B income is a lot to make in a single month. Wtf do I do with all this money?`}</p>
    <p>{`No, "Go shopping" is not the answer. Neither is "Give it to me", or "Drinks for everyone". I'm putting a lot of it towards my fuck-you-fund, investing some of it into prepaying a bunch of SaaS services for next year and… I don't know. Maybe crypto?`}</p>
    <p>{`Crucially, the sidehustle itself is not in a position to turn a financial injection like this into 2x money by buying ads or something. Not there yet.`}</p>
    <p>{`Second, I want to repeat this, but I don't know how. We're doing another StubHub workshop in Boston this month. That means it's going to be a good month, but not `}<em parentName="p">{`this`}</em>{` good.`}</p>
    <p>{`Maybe if I launch another product 🤔`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      